import Content from "../../../navigation/Routes";
import { Container } from "rsuite";
import React from "react";

export default function ContentLayout() {
  return <Content />;
}
